import * as React from 'react';
import { Trans } from 'react-i18next';

const PromotionHighlight = ({ children }: { children?: React.ReactNode }) => (
  <span style={{ color: '#41AAAF', fontWeight: 600 }}>{children}</span>
);

interface PromotionMessageProps {
  i18nKey: string;
}

export const PromotionMessage: React.FC<PromotionMessageProps> = ({
  i18nKey,
}) => (
  <Trans i18nKey={i18nKey} components={{ 1: <PromotionHighlight /> }} />
);
